import React, { useContext } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import AuthContext from '../../context/AuthContext';

const ProtectedRoute = ({ adminOnly = false, redirectPath = '/' }) => {
  const { user } = useContext(AuthContext);
  const location = useLocation();

  if (user === null) {
    return <div>Loading...</div>; // Show loading until user data is ready
  }

  if (!user) {
    return <Navigate to={redirectPath} state={{ from: location }} replace />;
  }

  // Restrict admin-only routes
  if (adminOnly && !user.isAdmin) {
    return <Navigate to="/dashboard" replace />;
  }

  return <Outlet />;
};

export default ProtectedRoute;
